import { useState } from "react";
import { MapPin, Phone, Mail, Clock, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import axios, { API, getErrorMessage } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export default function Kontak() {
  const { settings } = useSite();
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/public/contact`, form);
      toast.success("Pesan Anda telah terkirim. Tim kami akan segera menghubungi Anda.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (e) {
      toast.error(getErrorMessage(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="kontak-page">
      <section className="bg-gradient-to-br from-[#084C3A] to-[#0B4F71] px-4 py-16 text-center sm:px-6">
        <h1 className="font-heading text-3xl font-bold text-white sm:text-4xl">Hubungi Kami</h1>
        <p className="mt-3 text-white/80">Tim kami siap membantu pertanyaan Anda seputar Haji dan Umrah.</p>
      </section>

      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2">
        <div>
          <h2 className="font-heading text-xl font-bold text-[#1F2937]">Informasi Kontak</h2>
          <div className="mt-6 space-y-5 text-sm text-[#1F2937]">
            <p className="flex items-start gap-3"><MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#0F6B4F]" /> {settings?.address}</p>
            <p className="flex items-start gap-3"><Phone className="mt-0.5 h-5 w-5 shrink-0 text-[#0F6B4F]" /> {settings?.phone}</p>
            <p className="flex items-start gap-3"><Mail className="mt-0.5 h-5 w-5 shrink-0 text-[#0F6B4F]" /> {settings?.email}</p>
            <p className="flex items-start gap-3"><Clock className="mt-0.5 h-5 w-5 shrink-0 text-[#0F6B4F]" /> {settings?.service_hours || "Senin - Sabtu, 08.00 - 17.00 WIB"}</p>
          </div>
          <div className="mt-8 h-56 rounded-2xl bg-[#F5F9F7] flex items-center justify-center">
            <a href={settings?.maps_url} target="_blank" rel="noreferrer" data-testid="kontak-maps-link" className="text-sm font-medium text-[#0F6B4F] hover:underline">
              Buka Lokasi di Google Maps
            </a>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="rounded-2xl bg-white p-7 shadow-[0_2px_16px_rgba(15,107,79,0.06)]" data-testid="kontak-form">
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <Label>Nama Lengkap</Label>
              <Input data-testid="kontak-name-input" required value={form.name} onChange={(e) => update("name", e.target.value)} className="mt-1.5 h-11 rounded-xl" />
            </div>
            <div>
              <Label>Nomor HP</Label>
              <Input data-testid="kontak-phone-input" required value={form.phone} onChange={(e) => update("phone", e.target.value)} className="mt-1.5 h-11 rounded-xl" />
            </div>
          </div>
          <div className="mt-4">
            <Label>Email</Label>
            <Input data-testid="kontak-email-input" type="email" required value={form.email} onChange={(e) => update("email", e.target.value)} className="mt-1.5 h-11 rounded-xl" />
          </div>
          <div className="mt-4">
            <Label>Subjek</Label>
            <Input data-testid="kontak-subject-input" required value={form.subject} onChange={(e) => update("subject", e.target.value)} className="mt-1.5 h-11 rounded-xl" />
          </div>
          <div className="mt-4">
            <Label>Pesan</Label>
            <Textarea data-testid="kontak-message-input" required rows={4} value={form.message} onChange={(e) => update("message", e.target.value)} className="mt-1.5 rounded-xl" />
          </div>
          <Button type="submit" disabled={loading} data-testid="kontak-submit-button" className="mt-6 h-11 w-full rounded-full bg-gradient-to-r from-[#0F6B4F] to-[#1677B8] text-white hover:opacity-90">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Kirim Pesan"}
          </Button>
        </form>
      </div>
    </div>
  );
}
